import { uuid } from 'vue-uuid';
import { IFeeVueModel } from "@/ts/models/IFeeVueModel";
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import { IMaterialItemVueModel } from "@/ts/models/IMaterialItemVueModel";
import { IOperatingHoursVueModel } from "@/ts/models/IOperatingHoursVueModel";
import { IAddressVueModel } from './models/IAddressVueModel';
import { IContactVueModel } from './models/IContactVueModel';

const CurrentYear: number = new Date().getFullYear();

export class ReportingPeriods {
    getYears(): number[] {
        let items: number[] = [];
        for (let i = 0; i < 4; i++) {
            items.push(CurrentYear - i);
        }
        return items;
    }

    biAnnual = [
        { id: uuid.v4(), name: "Jan 1 - Jun 30 (due August 31)", value: new Date(CurrentYear, 0) },
        { id: uuid.v4(), name: "Jul 1 - Dec 31 (due February 28)", value: new Date(CurrentYear, 5) }
    ];
    quarterly = [
        { id: uuid.v4(), name: "Jan 1 - Mar 31 (due April 30)", value: new Date(CurrentYear, 0) },
        { id: uuid.v4(), name: "Apr 1 - Jun 30 (due July 31)", value: new Date(CurrentYear, 2) },
        { id: uuid.v4(), name: "Jul 1 - Sep 30 (due October 31)", value: new Date(CurrentYear, 5) },
        { id: uuid.v4(), name: "Oct 1 - Dec 31 (due January 31)", value: new Date(CurrentYear, 9) }
    ];

    getBiAnnual(year: number): IReportingPeriod[] {
        return [
            { id: "Q1Q2", name: "Jan 1 - Jun 30 (due August 31)", value: new Date(year, 0), code: "Q1Q2" },
            { id: "Q3Q4", name: "Jul 1 - Dec 31 (due February 28)", value: new Date(year, 5), code: "Q3Q4" }
        ];
    }

    getQuarterly(year: number): IReportingPeriod[] {
        return [
            { id: "Q1", name: "Jan 1 - Mar 31 (due April 30)", value: new Date(year, 0), code: "Q1" },
            { id: "Q2", name: "Apr 1 - Jun 30 (due July 31)", value: new Date(year, 2), code: "Q2" },
            { id: "Q3", name: "Jul 1 - Sep 30 (due October 31)", value: new Date(year, 5), code: "Q3" },
            { id: "Q4", name: "Oct 1 - Dec 31 (due January 31)", value: new Date(year, 9), code: "Q4" }
        ];
    }
}

export interface IReportingPeriod {
    id: string;
    name: string;
    value: Date;
    code: string;
}

export class RecyclingFacilityData {
    get facilityAddresses(): IAddressVueModel[] {
        return [
            
        ];
    }

    get acceptedMaterials(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Aluminum Cans", code: "ALC" },
            { id: uuid.v4(), isSelected: false, name: "Aluminum Scrap", code: "ALS" },
            { id: uuid.v4(), isSelected: false, name: "Batteries", code: "BAT" },
            { id: uuid.v4(), isSelected: false, name: "Bi-metal or Tin Cans", code: "BIM" },
            { id: uuid.v4(), isSelected: false, name: "Construction & Demolition Debris (List all Below) *1", code: "CAD" },
            { id: uuid.v4(), isSelected: false, name: "Corrugated Cardboard", code: "CGC" },
            { id: uuid.v4(), isSelected: false, name: "Ferrous Metal Scrap", code: "FMS" },
            { id: uuid.v4(), isSelected: false, name: "Glass Containers", code: "GLC" },
            { id: uuid.v4(), isSelected: false, name: "High Density Polyethylene (HDPE)", code: "HDP" },
            { id: uuid.v4(), isSelected: false, name: "Low Density Polyethylene (LDPE)", code: "LDP" },
            { id: uuid.v4(), isSelected: false, name: "Motor Vehicles / Vehicle Parts *2", code: "MVP" },
            { id: uuid.v4(), isSelected: false, name: "Non-Ferrous Metal Scrap", code: "NMS" },
            { id: uuid.v4(), isSelected: false, name: "Polyethylene Terephthalate (PET)", code: "PET" },
            { id: uuid.v4(), isSelected: false, name: "Polypropylene", code: "PYP" },
            { id: uuid.v4(), isSelected: false, name: "Polystyrene", code: "PYS" },
            { id: uuid.v4(), isSelected: false, name: "Propane Tanks / Cylinder Tanks", code: "PCT" },
            { id: uuid.v4(), isSelected: false, name: "Rubber / Tires *3", code: "RBT" },
            { id: uuid.v4(), isSelected: false, name: "Textiles", code: "TXT" },
            { id: uuid.v4(), isSelected: false, name: "Other Materials (List Below) *4", code: "OMS" },
            { id: uuid.v4(), isSelected: false, name: "Landscape/Yard Waste", code: "LSCP" },
            { id: uuid.v4(), isSelected: false, name: "Wood", code: "WOOD" },
            { id: uuid.v4(), isSelected: false, name: "Paper", code: "PPR" },
            { id: uuid.v4(), isSelected: false, name: "Electronics", code: "ELCT" },
            { id: uuid.v4(), isSelected: false, name: "Food", code: "FOOD" }
        ];
    }

    get rockCrushingAcceptedMaterials(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Broken Concrete", code: "BRC" },
            { id: uuid.v4(), isSelected: false, name: "Bricks", code: "BRK" },
            { id: uuid.v4(), isSelected: false, name: "Rock", code: "RCK" },
            { id: uuid.v4(), isSelected: false, name: "Stone", code: "STN" },
            { id: uuid.v4(), isSelected: false, name: "Paving Asphalt", code: "PVA" },
        ];
    }

    get motorVehiclePartsOptions(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Vehicles are drained of fluids prior to dismantling", code: "DRAIN" },
            { id: uuid.v4(), isSelected: false, name: "Vehicle dismantling on concrete pad", code: "CONCRETE" },
            { id: uuid.v4(), isSelected: false, name: "Freon evacuated by certified technician", code: "FREON" },
            { id: uuid.v4(), isSelected: false, name: "Vehicles crushed by car crusher", code: "CARCRUSHER" }
        ];
    }

    get materialSortingMethods(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Hand sorted", code: "HAND" },
            { id: uuid.v4(), isSelected: false, name: "Mechanically sorted", code: "MECHANICAL" },
            { id: uuid.v4(), isSelected: false, name: "N/A", code: "MSMNA" }
        ];
    }

    get materialProcessingMethods(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Bailing", code: "BAILING" },
            { id: uuid.v4(), isSelected: false, name: "Bundling", code: "BUNDLING" },
            { id: uuid.v4(), isSelected: false, name: "Compacting", code: "COMPACTING" },
            { id: uuid.v4(), isSelected: false, name: "Composting", code: "COMPOSTING" },
            { id: uuid.v4(), isSelected: false, name: "Crushing", code: "CRUSHING" },
            { id: uuid.v4(), isSelected: false, name: "Cutting", code: "CUTTING" },
            { id: uuid.v4(), isSelected: false, name: "Shredding", code: "SHREDDING" },
            { id: uuid.v4(), isSelected: false, name: "N/A", code: "MPMNA" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "MPMOTHER" }
        ];
    }
}

export const RecyclingFacility = new RecyclingFacilityData();

export class CCDDApplicationData {

    get acceptedMaterials(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Concrete", code: "CRT" },
            { id: uuid.v4(), isSelected: false, name: "Bricks", code: "BRICKS" },
            { id: uuid.v4(), isSelected: false, name: "Rock", code: "ROCK" },
            { id: uuid.v4(), isSelected: false, name: "Stone", code: "STONE" },
            { id: uuid.v4(), isSelected: false, name: "Soil", code: "SOIL" },
            { id: uuid.v4(), isSelected: false, name: "Reclaimed Asphalt Pavement", code: "RAP" },
            { id: uuid.v4(), isSelected: false, name: "Other Masonry Materials", code: "OMM" },
            //{ id: uuid.v4(), isSelected: false, name: "Wood" },
            //{ id: uuid.v4(), isSelected: false, name: "Wall Coverings" },
            //{ id: uuid.v4(), isSelected: false, name: "Plaster" },
            //{ id: uuid.v4(), isSelected: false, name: "Drywall" },
            //{ id: uuid.v4(), isSelected: false, name: "Plumbing Fixtures" },
            //{ id: uuid.v4(), isSelected: false, name: "Non-asbestos Insulation" },
            //{ id: uuid.v4(), isSelected: false, name: "Roofing Shingles" },
            //{ id: uuid.v4(), isSelected: false, name: "Other Roof Coverings" },
            //{ id: uuid.v4(), isSelected: false, name: "Glass" },
            //{ id: uuid.v4(), isSelected: false, name: "Plastics" },
            //{ id: uuid.v4(), isSelected: false, name: "Electrical Wiring" },
            //{ id: uuid.v4(), isSelected: false, name: "Other Electrical Components" },
            //{ id: uuid.v4(), isSelected: false, name: "Piping" },
            //{ id: uuid.v4(), isSelected: false, name: "Incidental Materials" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "CCDDAMOTHER" }
        ];
    }
}

export const CCDD = new CCDDApplicationData();

export class ReportingMaterials {
    get emptyMaterialItem(): IMaterialItemVueModel {
        return {
            id: uuid.v4(),
            name: "",
            amount: 0.00,
            measure: "",
            code: ""
        }
    }
    
    get nonResidentialHauler(): IMaterialItemVueModel[] {
        return [
            { id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Waste collected for permanent disposal:", code: "PERMDISPOSE" },
            { id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Recyclables (not including materials listed below)", code: "RECYCLE" },
            { id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Yard Waste:", code: "YARDWASTE" },
            { id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Food Scraps:", code: "FOODSCRAPS" },
            { id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Electronics:", code: "ELECTRONICS" },
            { id: uuid.v4(), amount: 0.00, measure: "Tons", name: "White Goods:", code: "WHITEGOODS" }
        ];
    }

    get residentialHauler(): IMaterialItemVueModel[] {
        let data = this.nonResidentialHauler;
        data.push({ id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Household hazardous waste:", code: "HOUSEWASTE" });
        data.push({ id: uuid.v4(), amount: 0.00, measure: "Tons", name: "Pharmaceutical Waste:", code: "PHARMAWASTE" });
        return data;
    }
}

export class FormFieldData {
    getNewId(): string {
        return uuid.v4();
    }

    cities = [
        { id: "Alsip", name: "Alsip" },
        { id: "Arlington Heights", name: "Arlington Heights" },
        { id: "Barrington", name: "Barrington" },
        { id: "Barrington Hills", name: "Barrington Hills" },
        { id: "Bartlett", name: "Bartlett" },
        { id: "Bedford Park", name: "Bedford Park" },
        { id: "Bellwood", name: "Bellwood" },
        { id: "Bensenville", name: "Bensenville" },
        { id: "Berkeley", name: "Berkeley" },
        { id: "Berwyn", name: "Berwyn" },
        { id: "Blue Island", name: "Blue Island" },
        { id: "Bolingbrook", name: "Bolingbrook" },
        { id: "Bridgeview", name: "Bridgeview" },
        { id: "Broadview", name: "Broadview" },
        { id: "Brookfield", name: "Brookfield" },
        { id: "Buffalo Grove", name: "Buffalo Grove" },
        { id: "Burbank", name: "Burbank" },
        { id: "Burnham", name: "Burnham" },
        { id: "Burr Ridge", name: "Burr Ridge" },
        { id: "Calumet City", name: "Calumet City" },
        { id: "Calumet Park", name: "Calumet Park" },
        { id: "Chicago (Unincorporated)", name: "Chicago (Unincorporated)" },
        { id: "Chicago Heights", name: "Chicago Heights" },
        { id: "Chicago Ridge", name: "Chicago Ridge" },
        { id: "Cicero", name: "Cicero" },
        { id: "Country Club Hills", name: "Country Club Hills" },
        { id: "Countryside", name: "Countryside" },
        { id: "Crestwood", name: "Crestwood" },
        { id: "Deerfield", name: "Deerfield" },
        { id: "Des Plaines", name: "Des Plaines" },
        { id: "Dixmoor", name: "Dixmoor" },
        { id: "Dolton", name: "Dolton" },
        { id: "East Dundee", name: "East Dundee" },
        { id: "East Hazel Crest", name: "East Hazel Crest" },
        { id: "Elgin", name: "Elgin" },
        { id: "Elk Grove Village", name: "Elk Grove Village" },
        { id: "Elmhurst", name: "Elmhurst" },
        { id: "Elmwood Park", name: "Elmwood Park" },
        { id: "Evanston", name: "Evanston" },
        { id: "Evergreen Park", name: "Evergreen Park" },
        { id: "Flossmoor", name: "Flossmoor" },
        { id: "Ford Heights", name: "Ford Heights" },
        { id: "Forest Park", name: "Forest Park" },
        { id: "Forest View", name: "Forest View" },
        { id: "Franklin Park", name: "Franklin Park" },
        { id: "Glencoe", name: "Glencoe" },
        { id: "Glenview", name: "Glenview" },
        { id: "Glenwood", name: "Glenwood" },
        { id: "Golf", name: "Golf" },
        { id: "Hanover Park", name: "Hanover Park" },
        { id: "Harvey", name: "Harvey" },
        { id: "Harwood Heights", name: "Harwood Heights" },
        { id: "Hazel Crest", name: "Hazel Crest" },
        { id: "Hickory Hills", name: "Hickory Hills" },
        { id: "Hillside", name: "Hillside" },
        { id: "Hinsdale", name: "Hinsdale" },
        { id: "Hodgkins", name: "Hodgkins" },
        { id: "Hoffman Estates", name: "Hoffman Estates" },
        { id: "Hometown", name: "Hometown" },
        { id: "Homewood", name: "Homewood" },
        { id: "Indian Head Park", name: "Indian Head Park" },
        { id: "Inverness", name: "Inverness" },
        { id: "Justice", name: "Justice" },
        { id: "Kenilworth", name: "Kenilworth" },
        { id: "La Grange", name: "La Grange" },
        { id: "La Grange Park", name: "La Grange Park" },
        { id: "LaGrange Highlands", name: "LaGrange Highlands" },
        { id: "Lansing", name: "Lansing" },
        { id: "Lemont", name: "Lemont" },
        { id: "Lincolnwood", name: "Lincolnwood" },
        { id: "Lynwood", name: "Lynwood" },
        { id: "Lyons", name: "Lyons" },
        { id: "Markham", name: "Markham" },
        { id: "Matteson", name: "Matteson" },
        { id: "Maywood", name: "Maywood" },
        { id: "McCook", name: "McCook" },
        { id: "Melrose Park", name: "Melrose Park" },
        { id: "Merrionette Park", name: "Merrionette Park" },
        { id: "Midlothian", name: "Midlothian" },
        { id: "Morton Grove", name: "Morton Grove" },
        { id: "Mount Prospect", name: "Mount Prospect" },
        { id: "Niles", name: "Niles" },
        { id: "Norridge", name: "Norridge" },
        { id: "North Riverside", name: "North Riverside" },
        { id: "Northbrook", name: "Northbrook" },
        { id: "Northfield", name: "Northfield" },
        { id: "Northlake", name: "Northlake" },
        { id: "Norwood Park", name: "Norwood Park" },
        { id: "Oak Brook", name: "Oak Brook" },
        { id: "Oak Forest", name: "Oak Forest" },
        { id: "Oak Lawn", name: "Oak Lawn" },
        { id: "Oak Park", name: "Oak Park" },
        { id: "Olympia Fields", name: "Olympia Fields" },
        { id: "Orland Hills", name: "Orland Hills" },
        { id: "Orland Park", name: "Orland Park" },
        { id: "Palatine", name: "Palatine" },
        { id: "Palos Heights", name: "Palos Heights" },
        { id: "Palos Hills", name: "Palos Hills" },
        { id: "Palos Park", name: "Palos Park" },
        { id: "Park Forest", name: "Park Forest" },
        { id: "Park Ridge", name: "Park Ridge" },
        { id: "Phoenix", name: "Phoenix" },
        { id: "Posen", name: "Posen" },
        { id: "1Prospect Heights04", name: "Prospect Heights" },
        { id: "Richton Park", name: "Richton Park" },
        { id: "River Forest", name: "River Forest" },
        { id: "River Grove", name: "River Grove" },
        { id: "Riverdale", name: "Riverdale" },
        { id: "Riverside", name: "Riverside" },
        { id: "Robbins", name: "Robbins" },
        { id: "Rolling Meadows", name: "Rolling Meadows" },
        { id: "Roselle", name: "Roselle" },
        { id: "Rosemont", name: "Rosemont" },
        { id: "Sauk Village", name: "Sauk Village" },
        { id: "Schaumburg", name: "Schaumburg" },
        { id: "Schiller Park", name: "Schiller Park" },
        { id: "Skokie", name: "Skokie" },
        { id: "South Barrington", name: "South Barrington" },
        { id: "South Chicago Heights", name: "South Chicago Heights" },
        { id: "South Holland", name: "South Holland" },
        { id: "Steger", name: "Steger" },
        { id: "Stickney", name: "Stickney" },
        { id: "Stone Park", name: "Stone Park" },
        { id: "Streamwood", name: "Streamwood" },
        { id: "Summit", name: "Summit" },
        { id: "Thornton", name: "Thornton" },
        { id: "Tinley Park", name: "Tinley Park" },
        { id: "University Park", name: "University Park" },
        { id: "Westchester", name: "Westchester" },
        { id: "Western Springs", name: "Western Springs" },
        { id: "Wheeling", name: "Wheeling" },
        { id: "Willow Springs", name: "Willow Springs" },
        { id: "Wilmette", name: "Wilmette" },
        { id: "Winnetka", name: "Winnetka" },
        { id: "Worth", name: "Worth" }
    ];

    states = [
        { id: "1", name: "Alabama", abbrv: "AL" },
        { id: "2", name: "Alaska", abbrv: "AK" },
        { id: "3", name: "Arizona", abbrv: "AZ" },
        { id: "4", name: "Arkansas", abbrv: "AR" },
        { id: "5", name: "California", abbrv: "CA" },
        { id: "6", name: "Colorado", abbrv: "CO" },
        { id: "7", name: "Connecticut", abbrv: "CT" },
        { id: "8", name: "Delaware", abbrv: "DE" },
        { id: "9", name: "District Of Columbia", abbrv: "DC" },
        { id: "10", name: "Florida", abbrv: "FL" },
        { id: "11", name: "Georgia", abbrv: "GA" },
        { id: "12", name: "Hawaii", abbrv: "HI" },
        { id: "13", name: "Idaho", abbrv: "ID" },
        { id: "14", name: "Illinois", abbrv: "IL" },
        { id: "15", name: "Indiana", abbrv: "IN" },
        { id: "16", name: "Iowa", abbrv: "IA" },
        { id: "17", name: "Kansas", abbrv: "KS" },
        { id: "18", name: "Kentucky", abbrv: "KY" },
        { id: "19", name: "Louisiana", abbrv: "LA" },
        { id: "20", name: "Maine", abbrv: "ME" },
        { id: "21", name: "Maryland", abbrv: "MD" },
        { id: "22", name: "Massachusetts", abbrv: "MA" },
        { id: "23", name: "Michigan", abbrv: "MI" },
        { id: "24", name: "Minnesota", abbrv: "MN" },
        { id: "25", name: "Mississippi", abbrv: "MS" },
        { id: "26", name: "Missouri", abbrv: "MO" },
        { id: "27", name: "Montana", abbrv: "MT" },
        { id: "28", name: "Nebraska", abbrv: "NE" },
        { id: "29", name: "Nevada", abbrv: "NV" },
        { id: "30", name: "New Hampshire", abbrv: "NH" },
        { id: "31", name: "New Jersey", abbrv: "NJ" },
        { id: "32", name: "New Mexico", abbrv: "NM" },
        { id: "33", name: "New York", abbrv: "NY" },
        { id: "34", name: "North Carolina", abbrv: "NC" },
        { id: "35", name: "North Dakota", abbrv: "ND" },
        { id: "36", name: "Ohio", abbrv: "OH" },
        { id: "37", name: "Oklahoma", abbrv: "OK" },
        { id: "38", name: "Oregon", abbrv: "OR" },
        { id: "39", name: "Pennsylvania", abbrv: "PA" },
        { id: "40", name: "Rhode Island", abbrv: "RI" },
        { id: "41", name: "South Carolina", abbrv: "SC" },
        { id: "42", name: "South Dakota", abbrv: "SD" },
        { id: "43", name: "Tennessee", abbrv: "TN" },
        { id: "44", name: "Texas", abbrv: "TX" },
        { id: "45", name: "Utah", abbrv: "UT" },
        { id: "46", name: "Vermont", abbrv: "VT" },
        { id: "47", name: "Virginia", abbrv: "VA" },
        { id: "48", name: "Washington", abbrv: "WA" },
        { id: "49", name: "West Virginia", abbrv: "WV" },
        { id: "50", name: "Wisconsin", abbrv: "WI" },
        { id: "51", name: "Wyoming", abbrv: "WY" }
    ];

    streetTypes = [
        { id: "Avenue", name: "AVE" },
        { id: "Boulevard", name: "BLVD" },
        { id: "Circle", name: "CIR" },
        { id: "Court", name: "CT" },
        { id: "Crescent", name: "CRES" },
        { id: "Drive", name: "DR" },
        { id: "Expressway", name: "EXPY" },
        { id: "Highway", name: "HWY" },
        { id: "Lane", name: "LN" },
        { id: "Parkway", name: "PKWY" },
        { id: "Place", name: "PL" },
        { id: "Plaza", name: "PLZ" },
        { id: "Road", name: "RD" },
        { id: "Row", name: "ROW" },
        { id: "Square", name: "SQ" },
        { id: "Street", name: "ST" },
        { id: "Terrace", name: "TER" },
        { id: "Trail", name: "TRL" },
        { id: "Way", name: "WAY" }
    ];

    streetDirections = [
        { id: "E", name: "E" },
        { id: "N", name: "N" },
        { id: "NE", name: "NE" },
        { id: "NW", name: "NW"},
        { id: "S", name: "S" },
        { id: "SE", name: "SE" },
        { id: "SW", name: "SW" },
        { id: "W", name: "W" }
    ];

    materialMeasures = [
        { id: "Tons", name: "Tons" },
        { id: "Gallons", name: "Gallons" },
    ];

    municipalities = [
        "Alsip",
        "Arlington Heights",
        "Barrington",
        "Barrington Hills",
        "Bartlett",
        "Bedford Park",
        "Bellwood",
        "Bensenville",
        "Berkeley",
        "Berwyn",
        "Blue Island",
        "Bridgeview",
        "Broadview",
        "Brookfield",
        "Buffalo Grove",
        "Burbank",
        "Burnham",
        "Burr Ridge",
        "Calumet City",
        "Calumet Park",
        "Chicago",
        "Chicago Heights",
        "Chicago Ridge",
        "Cicero",
        "Country Club Hills",
        "Countryside",
        "Crestwood",
        "Deer Park",
        "Deerfield",
        "DesPlaines",
        "Dixmoor",
        "Dolton",
        "East Hazel Crest",
        "Elgin",
        "Elk Grove Village",
        "Elmhurst",
        "Elmwood Park",
        "Evanston",
        "Evergreeen Park",
        "Flossmoor",
        "Ford Heights",
        "Forest Park",
        "Forest View",
        "Frankfort",
        "Franklin Park",
        "Glencoe",
        "Glenview",
        "Glenwood",
        "Golf",
        "Hanover Park",
        "Harvey",
        "Harwood Heights",
        "Hazel Crest",
        "Hickory Hills",
        "Hillside",
        "Hinsdale",
        "Hodgkins",
        "Hoffman Estates",
        "Homer Glen",
        "Hometown",
        "Homewood",
        "Indian Head Park",
        "Inverness",
        "Justice",
        "Kenilworth",
        "LaGrange",
        "LaGrange Park",
        "Lansing",
        "Lemont",
        "Leyden",
        "Lincolnwood",
        "Lynwood",
        "Lyons",
        "Markham",
        "Matteson",
        "Maywood",
        "McCook",
        "Melrose Park",
        "Merrionette Park",
        "Midlothian",
        "Morton Grove",
        "Mount Prospect",
        "Niles",
        "Norridge",
        "North Riverside",
        "Northbrook",
        "Northfield",
        "Northlake",
        "Oak Brook",
        "Oak Forest",
        "Oak Lawn",
        "Oak Park",
        "Olympia Fields",
        "Orland Hills",
        "Orland Park",
        "Palatine",
        "Palos Heights",
        "Palos Hills",
        "Palos Park",
        "Park Forest",
        "Park Ridge",
        "Phoenix",
        "Posen",
        "Prospect Heights",
        "Richton Park",
        "River Forest",
        "River Grove",
        "Riverdale",
        "Riverside",
        "Robbins",
        "Rolling Meadows",
        "Roselle",
        "Rosemont",
        "Sauk Village",
        "Schaumburg",
        "Schiller Park",
        "Skokie",
        "South Barrington",
        "South Chicago Heights",
        "South Holland",
        "Steger",
        "Stickney",
        "Stone Park",
        "Stone Park",
        "Streamwood",
        "Summit",
        "Thornton",
        "Tinley Park",
        "Unincorporated Cook County",
        "University Park",
        "Westchester",
        "Western Springs",
        "Wheeling",
        "Willow Springs",
        "Wilmette",
        "Winnetka",
        "Woodridge",
        "Worth"
    ];

    countries = [
                "United States of America",
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo (the Democratic Republic of the)",
        "Congo",
        "Cook Islands",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands [Malvinas]",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan (Province of China)",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom of Great Britain and Northern Ireland",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
        "Åland Islands"
    ];


    facilityClasses = [
        { name: "Recycler Class I", desc: "Recycler Class I", value: 250 },
        { name: "Recycler Class II - < 500 tons/day", desc: "Recycler Class II - < 500 tons/day", value: 500 },
        { name: "Recycler Class II - 500 - 1000 tons/day", desc: "Recycler Class II - 500 - 1000 tons/day", value: 750 },
        { name: "Recycler Class II - > 1000 tons/day", desc: "Recycler Class II - > 1000 tons/day", value: 1000 },
        { name: "Recycler Class III", desc: "Recycler Class III", value: 1000 },
        { name: "Recycler Class IV-A", desc: "Recycler Class IV - A", value: 1000 },
        { name: "Recycler Class IV-B", desc: "Recycler Class IV - B", value: 1000 },
        { name: "Recycler Class V", desc: "Recycler Class V", value: 1500 }
    ];

    unitsOfMeasure = [
        "Pounds", "Tons", "Cubic Yards", "Units"
    ];

    materialNames = [
        "Brick / Block", "Broken Asphalt", "Broken Concrete", "Dirt / Soil / Clay", "Rock / Stone", "Other"
    ];

    recycledMaterials = [
        "Asphalt", "Auto Bodies", "Auto Parts", "Batteries", "Brick/Block", "Cardboard", "Carpet/Padding", "Concrete",
        "Electronics", "Food", "Gasoline", "Glass", "Landscape/Yard Waste (including grass, brush, leaves, wood not separated out)",
        "Metal", "Oil", "Paper", "Rock/Stone", "Rubber/Tires", "Shingles", "Dirt/Soil/Clay", "Textiles", "Wire", "Wood", "Other"
    ];

    nonRecycledMaterials = [
        "Asphalt", "Auto Bodies", "Auto Parts", "Batteries", "Brick/Block", "Cardboard", "Carpet/Padding", "Concrete",
        "Electronics", "Food", "Gasoline", "Glass", "Landscape/Yard Waste (including grass, brush, leaves, wood not separated out)",
        "Metal", "Oil", "Paper", "Rock/Stone", "Rubber/Tires", "Shingles", "Dirt/Soil/Clay", "Textiles", "Wire", "Wood", "Other"
    ];

    unitsOfMeasureReport = ["Tons"];

    unitsOfMeasureCCDDActivity = [
        "Pounds", "Tons", "Cubic Yards"
    ];

    cookCountyRegions = [
        "North", "South", "West", "North-West"
    ];

    get emptyAddress(): IAddressVueModel[] {
        return [
            { id: "", addressType: "", streetType: "", streetNumber: "", streetName: "", streetDirection: "", street2: "", city: "", state: "", zip: "", country: ""}
        ];
    }

    reportingPeriods = new ReportingPeriods();

    reportingMaterials = new ReportingMaterials();

    get operatingHours(): IOperatingHoursVueModel[] {
        return [
            { id: uuid.v4(), dayOfWeek: "Sunday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "SUN" },
            { id: uuid.v4(), dayOfWeek: "Monday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "MON" },
            { id: uuid.v4(), dayOfWeek: "Tuesday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "TUE" },
            { id: uuid.v4(), dayOfWeek: "Wednesday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "WED" },
            { id: uuid.v4(), dayOfWeek: "Thursday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "THU" },
            { id: uuid.v4(), dayOfWeek: "Friday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "FRI" },
            { id: uuid.v4(), dayOfWeek: "Saturday", isOpen: false, from: { h: "", mm: "", a: "" }, to: { h: "", mm: "", a: "" }, code: "SAT" }
        ];
    }

    get acceptedSources(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Public", code: "PUBLIC" },
            { id: uuid.v4(), isSelected: false, name: "Business", code: "BUSINESS" },
            { id: uuid.v4(), isSelected: false, name: "Government or Municipality", code: "GOVORMUC" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "ASOTHER" }
        ];
    }

    get odorPreventionMethods(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Deodorizer Spray", code: "DEODSPRAY" },
            { id: uuid.v4(), isSelected: false, name: "Deodorized Pellets", code: "DEODPELLETS" },
            { id: uuid.v4(), isSelected: false, name: "Removing Waste Daily", code: "WASTEDAILY" },
            { id: uuid.v4(), isSelected: false, name: "N/A", code: "ODERNA" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "OTHERNA" }
        ];
    }

    get noisePreventionMethods(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Enclosed Facility", code: "ENCLOSED" },
            { id: uuid.v4(), isSelected: false, name: "Operate Indoors", code: "INDOORS" },
            { id: uuid.v4(), isSelected: false, name: "Operate within Business Hours", code: "BUSHOURS" },
            { id: uuid.v4(), isSelected: false, name: "N/A", code: "NOISENA" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "NOISEOTHER" }
        ];
    }

    get dustPreventionMethods(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Operate on Graded and Paved Surfaces", code: "PAVED" },
            { id: uuid.v4(), isSelected: false, name: "Sprinkler System", code: "SPRINKLER" },
            { id: uuid.v4(), isSelected: false, name: "Street Sweep: Yard, Driveways, Access Road, Parking Areas", code: "STREETSWEEP" },
            { id: uuid.v4(), isSelected: false, name: "Water Material", code: "WATERMAT" },
            { id: uuid.v4(), isSelected: false, name: "N/A", code: "DUSTNA" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "DUSTOTHER" }
        ];
    }

    get cleaningProcedures(): ISelectItemVueModel[] {
        return [
            { id: uuid.v4(), isSelected: false, name: "Pick Up Wind Blown Litter", code: "LITTER" },
            { id: uuid.v4(), isSelected: false, name: "Inbound & Outbound Loads to be Covered", code: "COVERED" },
            { id: uuid.v4(), isSelected: false, name: "Vector / Pest Control", code: "VECTOR" },
            { id: uuid.v4(), isSelected: false, name: "Regular Facility Cleaning", code: "RFC" },
            { id: uuid.v4(), isSelected: false, name: "Regularly Removing Waste", code: "RRM" },
            { id: uuid.v4(), isSelected: false, name: "Other *", code: "COTHER" }
        ];
    }

    getFee(formName: string): IFeeVueModel {
        if (formName === "RecyclingFacilityApplication") {
            return { id: uuid.v4(), name: "Facility Class Fee", amount: 0, code: "RECYCLE" };
        }
        if (formName === "CCDDApplication") {
            return { id: uuid.v4(), name: "CCDD Fee", amount: 2000, code: "CCDD" };
        }
        if (formName === "LiquidHazardousWaste") {
            return { id: uuid.v4(), name: "Volume Fee", amount: 0, code: "LIQUID" };
        }
        if (formName === "TransferStation") {
            return { id: uuid.v4(), name: "Material Weight Fee", amount: 0, code: "TRANSFER" };
        }
        if (formName === "RockCrushingApplication") {
            return { id: uuid.v4(), name: "Rock Crushing Fee", amount: 0, code: "ROCK" };
        }

        return { id: "", name: "", amount: 0, code: "" };
    }
}

export default new FormFieldData();